// extracted by mini-css-extract-plugin
export default {"popover":"popover__whkMDg4Q","tooltip":"tooltip__HYf1FtVJ"};